module.exports = __webpack_public_path__ + "img/DE00001.0c355602.png";